import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("g", {
        clipPath: "url(#uz0ipmlbq__clip0_16836_221136)",
        children: _jsxs("g", {
          clipPath: "url(#kgkda3jq6__clip1_16836_221136)",
          children: [_jsx("path", {
            d: "M38 0H-7V30H38V0Z",
            fill: "#4189DD"
          }), _jsx("path", {
            d: "M15.5 7.78027L13.27 14.6453L16.705 15.7603L15.5 7.78027Z",
            fill: "white"
          }), _jsx("path", {
            d: "M15.5004 7.78027L17.7304 14.6453L14.2954 15.7603L15.5004 7.78027Z",
            fill: "white"
          }), _jsx("path", {
            d: "M22.369 12.7695H15.144V16.3795L22.369 12.7695Z",
            fill: "white"
          }), _jsx("path", {
            d: "M22.3693 12.7695L16.5243 17.0145L14.4043 14.0895L22.3693 12.7695Z",
            fill: "white"
          }), _jsx("path", {
            d: "M8.62891 12.7695L14.4739 17.0145L16.5939 14.0895L8.62891 12.7695Z",
            fill: "white"
          }), _jsx("path", {
            d: "M8.62891 12.7695H15.8539V16.3795L8.62891 12.7695Z",
            fill: "white"
          }), _jsx("path", {
            d: "M19.7451 20.8456L17.5151 13.9756L14.0801 15.0906L19.7451 20.8456Z",
            fill: "white"
          }), _jsx("path", {
            d: "M19.7454 20.8448L13.9004 16.5998L16.0254 13.6748L19.7454 20.8448Z",
            fill: "white"
          }), _jsx("path", {
            d: "M11.2544 20.8448L17.0994 16.5998L14.9744 13.6748L11.2544 20.8448Z",
            fill: "white"
          }), _jsx("path", {
            d: "M11.2544 20.8456L13.4844 13.9756L16.9194 15.0906L11.2544 20.8456Z",
            fill: "white"
          })]
        })
      }), _jsx("rect", {
        x: "1",
        y: "1",
        width: "28",
        height: "28",
        rx: "14",
        stroke: "#152361",
        strokeWidth: "2"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "uz0ipmlbq__clip0_16836_221136",
          children: _jsx("rect", {
            width: "30",
            height: "30",
            rx: "15",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "kgkda3jq6__clip1_16836_221136",
          children: _jsx("rect", {
            width: "45",
            height: "30",
            fill: "white",
            transform: "translate(-7)"
          })
        })]
      })]
    }))
  });
};
export default Component;
